<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="version">v{{ APP_VERSION }}</div>
      <div class="copyright">
        &copy; {{ footerYear }}, developed by
        <a :href="footerWebsite" target="_blank">{{ footerCompany }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
import { version } from "../../package.json";

export default {
  name: "ContentFooter",
  props: {
    footerWebsite: {
      type: String,
      required: true,
    },
    footerCompany: {
      type: String,
      required: true,
    },
    footerYear: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      APP_VERSION: version,
    };
  },
};
</script>

<style>
.version {
  display: inline-block;
}
</style>
